<template>
  <div class="l-learn-silence-read">
    <div class="l-learn-finger-read l-learn-content-container" v-if="element">
      <img src="./images/logo.png" alt="" class="finger-read__logo">
      <img src="./images/spirt.png" alt="" class="finger-read__boy">
      <div ref="fingerReadContainer" class="finger-read__container">
          <div ref="fingerReadContent"
              class="finger-read__content__text"
              @mousedown="handleSwipeStart"
              @mouseup="handleSwipeEnd"
              @mousemove="handleMouseMove"
              @touchstart="handleSwipeStart"
              @touchend="handleSwipeEnd"
              @touchmove="handleTouchMove">
              <div class="item-wrap" 
                  v-for="(paragraph, lineIndex) in contentArr"
                  :key="paragraph.time">
                  <p class="finger-read__content__text__item"
                      :class="{
                          'active': lineIndex === currentLineIndex,
                          'readed': lineIndex <= currentLineIndex,
                      }"
                      :data-line-index="lineIndex">
                      <span 
                          v-for="(word, index) in paragraph" 
                          :key="index" 
                          :data-index="index"
                      >{{ word }}</span>
                  </p>
              </div>
          </div>
      </div>
    </div>

    <button
      class="submit-btn"
      :class="{ 'submit-btn-disabled': isSubmitButtonDisabled }"
      @click="ended"
      :disabled="isSubmitButtonDisabled">
    </button>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import elementTypes from '../../minxin/elementTypes'

const { mapGetters, mapActions } = createNamespacedHelpers('course')

export default {
  name: 'l-learn-silence-read',
  mixins: [elementTypes],
  props: {
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      started: false,
      countDown: 0,
      isDrawing: false,
      // 已经读过的单词的索引
      currentLineIndex: 0,
      readIndexList: {},
      isSubmitButtonDisabled: true,
    }
  },
  computed: {
    ...mapGetters(['element']),
    storyContent() {
      return this.element.attrs.storyContent
    },
    contentArr() {
      return this.storyContent.split('\n').map((item) => (item.split(' ')))
    } 
  },
  methods: {
    ...mapActions(['STUDY_RESULT']),
    // 计算音频当前播放到第几行
    calcCurrentLineIndex(newTime) {
      const index = this.contentArr.findIndex((item, index) => {
          return newTime >= item.time && newTime <= (this.contentArr[index + 1]?.time || this.laudio.duration * 1000)
      }); 
      this.currentLineIndex = index;
    },
    // 计算正确率
    calcAccuracy() {
      const total = this.contentArr.reduce((prev, item) => {
          return prev + item.length;
      }, 0);
      const readTotal = Object.values(this.readIndexList).reduce((prev, item) => {
          return prev + item.length;
      }, 0);
      return readTotal / total * 100
    },
    // 结束
    async ended() {
      this.started = false;
        // 先上传作答成绩
      await this.STUDY_RESULT({
        elementId: this.$route.query.dataId,
        postData: {
          score: this.calcAccuracy(),
        },
      })
      this.$emit('submit')
    },

    handleSwipeStart() {
      this.isDrawing = true;
    },
    handleSwipeEnd() {
      this.isDrawing = false;
    },
    handleSwipe(el) {
        if (!this.isDrawing) return;
        if (el.tagName.toLowerCase() !== 'span') return;
        const elParentNodeLineIndex = Number(el.parentNode.dataset.lineIndex);

        el.style.color = 'red';
        this.readIndexList[elParentNodeLineIndex] = this.readIndexList[elParentNodeLineIndex] || [];
        if (!this.readIndexList[elParentNodeLineIndex].includes(Number(el.dataset.index))) {
            this.readIndexList[elParentNodeLineIndex].push(Number(el.dataset.index));
        }
        const accuracy = this.calcAccuracy();
        if (accuracy >= 80) {
            this.isSubmitButtonDisabled = false;
        }
    },
    handleMouseMove(event) {
      if (!this.isDrawing) return
      // Add this check to ensure the function only runs when a mouse button is pressed
      if (event.buttons === 0) return

      const container = this.$refs.fingerReadContent
      if (!container) return

      const rect = container.getBoundingClientRect()
      // Add this check to ensure the mouse is within the bounds of the element
      if (
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom
      ) {
        return
      }

      this.handleSwipe(event.target);
    },
    handleTouchMove(e) {
      const touch = e.touches[0];
      const el = document.elementFromPoint(touch.clientX, touch.clientY);
      this.handleSwipe(el);
    },
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>
<style scoped>
.l-learn-silence-read {
  position: relative;
  padding-left: 12px;
  box-sizing: border-box;
  width: 80%;
  height: 80%;
  top: -56px;
}

.finger-read__mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(200, 200, 200, 0.5);
    border-radius: 40px;
    color: #fff;
    font-size: 20px;
}
.finger-read__mask-text {
    font-size: 80px;
    font-weight: bold;
    color: #ea9c2c;
}
.finger-read__play__btn {
    width: 120px;
    height: 100px;
    cursor: pointer;
}
.finger-read__play__btn img {
    width: 100%;
    height: 100%;
}

.finger-read__logo {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 160px;
}
.finger-read__boy {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 200px;
}

.finger-read__container {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 180px 20px 120px;
  overflow: auto;
}
.action-btn {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 10;
}
.finger-read__content__text {
    font-size: 36px;
    font-weight: bold;
    user-select: none;
}
.item-wrap {
    /* margin-bottom: 20px; */
}
.finger-read__current-label {
    float: left;
    width: 62px;
    height: 48px;
    padding-top: 16px;
    margin-left: -82px;
    margin-right: 20px;
}
.finger-read__content__text__item {
    flex: 1;
    margin: 0;
    text-align: left;
    color: #1F094C;
}
.finger-read__content__text span {
    display: inline-block;
    padding: 16px 8px 52px;
    transition: color 0.3s;
}

.submit-btn {
    position: absolute;
    bottom: -100px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    width: 385px;
    height: 86px;
    background: url('./images/submit-btn.png') center bottom no-repeat;
    background-size: 100% 100%;
    border: none;
    cursor: pointer;
}
.submit-btn:active {
    background: url('./images/submit-btn-active.png') center bottom no-repeat;
    background-size: 100% 64px;
}
.submit-btn-disabled {
    filter: grayscale(100%);
    cursor: not-allowed;
}
</style>
